import React, {useEffect, useRef, useState} from 'react'
import Draggable from 'react-draggable';
import PotatoHuntOnStartAnimation from "./PotatoHuntOnStartAnimation";
import {useTranslation} from "react-i18next";

export default function PotatoHuntStepGrid(props) {
	const {imagePath, onNextStep, onSelectCell} = props;
	const {t, i18n} = useTranslation();


	const nodeRef = useRef(null);
	const potatoHuntGridRef = useRef(null);
	const dragContainerRef = useRef(null);

	const [position, setPosition] = useState({x: 0, y: 0});
	const [isClick, setIsClick] = useState(false)
	const [isOnStart, setIsOnStart] = useState(true)
	const [bounds, setBounds] = useState({left: 0, right: 0, top: 0, bottom: 0})
	const [selectedCellIndex, setSelectedCellIndex] = useState('0')

	const handleOnMouseDown = (e) => {
		setIsClick(true)
	}
	const handleStart = (e, data) => {
		setIsOnStart(false)
		if (data) {
			// Restrict drag inside container
			const dragContainerWidth = dragContainerRef.current.offsetWidth
			const dragContainerHeight = dragContainerRef.current.offsetHeight
			const dragWidth = nodeRef.current.offsetWidth
			const dragHeight = nodeRef.current.offsetHeight
			let x = dragWidth - dragContainerWidth;
			const top = dragHeight - dragContainerHeight

			setBounds({left: -x, right: 0, top: -top, bottom: 0})
		}
	}

	const handleDrag = (e, data) => {
		setIsClick(false);
		setPosition({x: data.x, y: data.y});
	};
	const handleStop = () => {
	}
	const handleCellClick = (e) => {
		setSelectedCellIndex(e.target.dataset.index)

	}

	useEffect(() => {
		let clickTimer = setTimeout(() => {
			if (isClick === true) {
				// Click on a cell will lead to nex step
				onNextStep()

				// Set selected cell
				if (selectedCellIndex % 2 === 0) {
					onSelectCell('even')
				} else {
					onSelectCell('odd')
				}
			}
		}, 300);

		return () => {
			clearTimeout(clickTimer);
		};

	}, [isClick, selectedCellIndex]);


	return (
		<div className="potato-hunt-sub-component potato-hunt-grid-component">

			<div ref={dragContainerRef} className="potato-hunt-sub-component--inner">
				<div className="potato-hunt-grid-wrap">
						imageName="potato-hunt/Lays_move_animation.gif"
					<PotatoHuntOnStartAnimation
						imagePath={imagePath}
						imageName={'potato-hunt/'+ t('Lays_move_animation.gif')}
						altText="move animation"
						isOnStart={isOnStart}/>
					<div ref={potatoHuntGridRef} className="potato-hunt-grid">

						<Draggable
							bounds={bounds}
							nodeRef={nodeRef}
							grid={[75, 75]}
							axis="both"
							position={position}
							onMouseDown={handleOnMouseDown}
							onStart={handleStart}
							onDrag={handleDrag}
							onStop={handleStop}
						>
							<div className={"box "} ref={nodeRef}>
								<div className="grid-link-wrap">
									{Array.apply(null, {length: 400}).map((e, i) => (
										<div className="grid-link" key={i} onClick={handleCellClick} data-index={i}>

										</div>
									))}
								</div>
								<img src={imagePath + "potato-hunt/Lays_field_grid-20x20.webp"} alt="potato field"/>
							</div>
						</Draggable>
					</div>
				</div>
			</div>
		</div>
	)
}
